<template>
  <a-modal :title="title" :width="width" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="产品编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'productCode', validatorRules.productCode]" placeholder="请输入产品编码"></a-input>
        </a-form-item>
        <a-form-item label="产品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'productName', validatorRules.productName]" placeholder="请输入产品名称"></a-input>
        </a-form-item>
        <a-form-item label="产品介绍" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-editor v-decorator="['productIntroduce',{trigger:'input'}]" />
        </a-form-item>
        <a-form-item label="详情图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload :multiple="true" v-decorator="['detailPicAddress', validatorRules.detailPicAddress]"
            :uploadData="uploadData" :beforeUpload="beforeUploadDetail" :trigger-change="true">
          </j-upload>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['remarks', validatorRules.remarks]" rows="4" placeholder="请输入备注" />
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import {
    httpAction
  } from '@/api/manage'
  import pick from 'lodash.pick'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JUpload from '../../components/JUpload.vue'
  import JEditor from '@/components/jeecg/JEditor.vue'

  export default {
    name: "BusCommonDoorCodeModal",
    components: {
      JUpload,
      JEditor,
    },
    data() {
      return {
        form: this.$form.createForm(this),
        title: "操作",
        width: 800,
        visible: false,
        model: {},
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          },
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 16
          },
        },
        confirmLoading: false,
        validatorRules: {
          productCode: {
            rules: [{
              required: true,
              message: '请输入产品编码!'
            }, ]
          },
          productName: {
            rules: [{
              required: true,
              message: '请输入产品名称!'
            }, ]
          },
          productIntroduce: {
            rules: []
          },
          detailPicAddress: {
            rules: []
          },
          remarks: {
            rules: []
          },
        },
        url: {
          add: "/doorplank/base/busCommonDoorCode/add",
          edit: "/doorplank/base/busCommonDoorCode/edit",
        }
      }
    },
    created() {},
    methods: {
      add() {
        this.edit({});
      },
      edit(record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'productCode', 'productName', 'productIntroduce',
            'detailPicAddress', 'remarks'))
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      uploadData() {
        let filepathData = 'doorCodeDetail/' + this.form.getFieldValue('productCode')
        return {
          filePath: filepathData
        }
      },
      beforeUploadDetail(file, fileList) {
        const couponCode = this.form.getFieldValue('productCode')
        if (!couponCode) {
          this.$message.warning('请输入产品编码')
          fileList.forEach((item, index, input) => {
            if (item.lastModified == file.lastModified) {
              fileList.splice(index, 1)
            }
          })
          return false
        }
        var fileType = file.type
        if (fileType === 'image') {
          if (fileType.indexOf('image') < 0) {
            this.$message.warning('请上传图片')
            return false
          }
        } else if (fileType === 'file') {
          if (fileType.indexOf('image') >= 0) {
            this.$message.warning('请上传文件')
            return false
          }
        }
        //TODO 扩展功能验证文件大小
        return true
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据", formData)
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'productCode', 'productName', 'createBy', 'createTime', 'updateBy',
          'productIntroduce', 'detailPicAddress', 'remarks'))
      },


    }
  }
</script>